/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { groupsControllerAddGroupMember } from "./groupsControllerAddGroupMember";
import { groupsControllerCreateGroup } from "./groupsControllerCreateGroup";
import { groupsControllerCreatePrecedenceClause } from "./groupsControllerCreatePrecedenceClause";
import { groupsControllerDeletePrecedenceClause } from "./groupsControllerDeletePrecedenceClause";
import { groupsControllerGetDocumentEffectivePrecedenceOrders } from "./groupsControllerGetDocumentEffectivePrecedenceOrders";
import { groupsControllerGetDocumentGroups } from "./groupsControllerGetDocumentGroups";
import { groupsControllerGetProjectEffectivePrecedenceOrders } from "./groupsControllerGetProjectEffectivePrecedenceOrders";
import { groupsControllerGetProjectGroups } from "./groupsControllerGetProjectGroups";
import { groupsControllerRemoveGroupMember } from "./groupsControllerRemoveGroupMember";
import { groupsControllerUpdateGroupRanks } from "./groupsControllerUpdateGroupRanks";
import { groupsControllerVerifyGroupMember } from "./groupsControllerVerifyGroupMember";
import { groupsControllerVerifyPrecedenceClause } from "./groupsControllerVerifyPrecedenceClause";

export function documentGroupsService() {
  return { groupsControllerGetProjectGroups, groupsControllerCreateGroup, groupsControllerGetDocumentGroups, groupsControllerGetProjectEffectivePrecedenceOrders, groupsControllerGetDocumentEffectivePrecedenceOrders, groupsControllerCreatePrecedenceClause, groupsControllerDeletePrecedenceClause, groupsControllerVerifyPrecedenceClause, groupsControllerAddGroupMember, groupsControllerRemoveGroupMember, groupsControllerVerifyGroupMember, groupsControllerUpdateGroupRanks }
}